/**
 * This is groups script.js file
 */

import tableList from '@/inheritance/table-list';

export default {
  name: 'PermissionSet',
  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: tableList,

  /**
   * @override
   */
  data() {
    return {
      listSearching: false
    };
  },
  methods: {
    /**
     * Obtenemos la lista de usuarios desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }
      const payload = {
        section: 'permission_set',
        cfg
      };

      if (sort && sort !== 'false') {
        payload.sort = sort;
      }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          this.items = this.mapSelfName(res.data.permission_sets, ['key_name']);
          this.getColumns();
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => {
          this.listSearching = false;

          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },

    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, 'col_perm');
    },

    /**
     * Ordenamos la tabla por un campo específico
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};
      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_perm');
      } else {
        this.removeFromLocalstore('ob_perm');
      }
      this.loadItems(field, cfg);
    },
    /**
     * Aplicamos los filtros seleccionados
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      this.saveFilterInLocalstore(filters, 'filt_perm');
      if (filters.length >= 1) {
        this.tbFilters = filters;
        this.applyFilters(filters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },
    /**
     * @override
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'permission_set',
        href: this.metadata.paging._links._next.href
      };
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            this.metadata = res.metadata;
            this.items = [...this.items, ...this.loadDataInTable(res.data.permission_sets, ['key_name'])];
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
      }
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_perm');
      this.loadItems();
    },

    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_perm');
      this.removeFromLocalstore('ob_perm');
      this.removeFromLocalstore('col_perm');
      this.removeFromLocalstore('search_perm');
      this.loadView(view);
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'permission_set';
    this.loadSectionViews();
  },

  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   */
  mounted() {
    this.defaultColumns = ['key_name', 'description', 'display_name'];
    this.tbFilters = this.loadFilterInLocalstore('filt_perm');
    this.orderby = this.loadFilterInLocalstore('ob_perm');
    this.search = this.loadFilterInLocalstore('search_perm');

    this.addFiltersToRequest(this.tbFilters);

    if (
      this.orderby &&
      this.orderby !== 'false' &&
      this.orderby.length > 0 &&
      this.orderby !== this.$route.query['sorts-by']
    ) {
      this.$router
        .replace({
          path: this.$route.fullPath,
          query: { 'sorts-by': this.orderby }
        })
        .then(() => {
          this.sort(this.orderby);
        });
    } else {
      this.loadItems();
    }
    this.columns = this.loadFilterInLocalstore('col_perm');
  }
};
